
import { TripList, TripViewDetails } from "../../../pages";
import superadminRoutesMap from "../../../routeControl/superadminRoutes";

export default function route() {
  return [
    {
      path: superadminRoutesMap.TRIPSLIST.path,
      name: "Trip List",
      key: superadminRoutesMap.USERLIST.path,
      private: true,
      belongsToSidebar: true,
      icon: "tripon-trips",
      element: <TripList />,
    },
    {
      path: `${superadminRoutesMap.VIEWTRIP.path}/:id`,
      name: "Trip View Details",
      key: `${superadminRoutesMap.VIEWTRIP.path}/:id`,
      private: true,
      belongsToSidebar: false,
      element: <TripViewDetails />,
    },
  ];
}
